import classnames from "classnames";
import { ActivePagePathProps } from "components/apiDocs/ApiSidebar/ApiSidebar";
import React from "react";
import { Link } from "react-router-dom";
import routeConstants from "utils/routeConstants";

import { StyledHeader, Title } from "./style";

const BrowseAllLink: React.FC<ActivePagePathProps> = ({ activePagePath }) => {
  const defaultActivePage = "/";
  return (
    <Link to={`${routeConstants.apiDocs}`}>
      <StyledHeader
        className={classnames("card-header top-bottom-border", {
          "is-active": activePagePath === defaultActivePage,
        })}
        data-test-id="api-category-dropdown-browse-all"
      >
        <Title
          className="card-header-title"
          data-test-id="api-category-dropdown-title"
        >
          Browse All
        </Title>
      </StyledHeader>
    </Link>
  );
};

export default BrowseAllLink;
